// src/redux/dateSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the date state
interface DateState {
    fromDate: string;
    toDate: string;
}

// Define the initial state
const initialState: DateState = {
    fromDate: '',
    toDate: '',
};

// Create the slice
const dateSlice = createSlice({
    name: 'date',
    initialState,
    reducers: {
        setFromDate: (state, action: PayloadAction<string>) => {
            state.fromDate = action.payload;
        },
        setToDate: (state, action: PayloadAction<string>) => {
            state.toDate = action.payload;
        },
        setDates: (state, action: PayloadAction<{ fromDate: string; toDate: string }>) => {
            state.fromDate = action.payload.fromDate;
            state.toDate = action.payload.toDate;
        },
    },
});

// Export actions
export const { setFromDate, setToDate, setDates } = dateSlice.actions;

// Export the reducer
export default dateSlice.reducer;
